import React, { useState } from 'react';
import { Form, Row, Col, Modal, Button } from 'react-bootstrap';
import { useForm, Controller } from 'react-hook-form';
import '@maersk-global/mds-components-core-icon';
import { McCard, McIcon, McTag } from "@maersk-global/mds-react-wrapper"
import { McButton, McInput, McInputDate, McDialog } from "@maersk-global/mds-react-wrapper/components-core";
import './ContainerSearchForm.scss';
import "@maersk-global/mds-react-wrapper/styles/core.css";
import { FaSyncAlt } from 'react-icons/fa';

interface Filters {
  containerNumber: string[];
  bookingNumber: string;
  sealNumber: string;
  fromDate: string;
  toDate: string;
}

interface ContainerSearchFormProps {
  onSubmit: (data: Filters) => void;
  onReset: () => void;
}

const ContainerSearchForm: React.FC<ContainerSearchFormProps & {isLoading: boolean}> = ({ onSubmit, onReset,isLoading }) => {
  const { control, handleSubmit, reset, getValues } = useForm<Filters>({
    defaultValues: {
      containerNumber: [],
      bookingNumber: '',
      sealNumber: '',
      fromDate: '',
      toDate: ''
    }
  });

  const handlekeyDown = (event:React.KeyboardEvent)=>{
    if (event.key === "Enter"){
      event.preventDefault();
      const formData=getValues();
      const isAllFieldsEmpty =
      formData.containerNumber.length === 0 &&
      !formData.bookingNumber &&
      !formData.sealNumber &&
      !formData.fromDate &&
      !formData.toDate;

    const isOnlyDatesFilled =
      formData.containerNumber.length === 0 &&
      !formData.bookingNumber &&
      !formData.sealNumber &&
      (formData.fromDate || formData.toDate);

    
    if (isAllFieldsEmpty || isOnlyDatesFilled) {
      setDialogHeading("Missing Information");
      setDialogMessage("Please enter a Container Number, Booking Number, or Seal Number");
      setShowDialog(true);
      return;
    }
      onSubmit(formData);
    }
  }

  const [showDialog, setShowDialog] = useState(false);
  const [dialogMessage,setDialogMessage]=useState("");
  const [dialogHeading,setDialogHeading]=useState("");
  const [isDisabled,setIsDisabled] = useState(false);
  const [isBookingDisabled, setBookingDisabled] = useState(false);
  const [isSealDisabled, setSealDisabled] = useState(false);
  const [isFromDateInvalid,setIsFromDateInvalid] = useState(false);
  const [isToDateInvalid, setIsToDateInvalid]= useState(false);

  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

  const validateDate = (date:string, setter:React.Dispatch<React.SetStateAction<boolean>>)=>{
    if(date && !dateRegex.test(date)){
      setter(true);
    }else{
      setter(false);
    }
  }

  const handleContainerNumberChange = (value: string) => {
    const containerNumbers = value.split(',').map((num) => num.trim());
    if (containerNumbers.some((num) => num.length > 15)) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
    return containerNumbers;
  };

  const handleBookingInput = (value: string, onChange: (value: string) => void) => {
    const trimmedValue = value.trim();
    if (trimmedValue.length > 15) {
      setBookingDisabled(true);
    } else {
      setBookingDisabled(false);
    }
    onChange(trimmedValue);
  };

  const handleSealInput = (value: string, onChange: (value: string) => void) => {
    const trimmedValue = value.trim();
    if (trimmedValue.length > 15) {
      setSealDisabled(true);
    } else {
      setSealDisabled(false);
    }
    onChange(trimmedValue);
  };
  const submitForm = (data: Filters) => {
    if(isFromDateInvalid || isToDateInvalid){
      return;
    }
    const transformedData = {
      ...data,
      containerNumber:data.containerNumber.filter((num)=>num.trim()!=="").map((num)=>num.toUpperCase()),
      bookingNumber: data.bookingNumber.trim().toUpperCase(),
      sealNumber: data.sealNumber.trim().toUpperCase(),
    };

    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    const isFromDateValid = !transformedData.fromDate || dateRegex.test(transformedData.fromDate);
    const isToDateValid = !transformedData.toDate || dateRegex.test(transformedData.toDate);

    if(!isFromDateValid || !isToDateValid){
      setDialogHeading("Invalid Date");
      setDialogMessage("Please enter a valid date in YYYY-MM-DD format");
      setShowDialog(true);
      return;
    }

    const hasInvalidContainerNumber = 
    transformedData.containerNumber.some((num)=>num.length>=12);
    if (hasInvalidContainerNumber){
      setDialogHeading("Error");
      setDialogMessage("Please enter a Container Number with less than 12 digits.");
      setShowDialog(true);
      return;
    }
    const isAllFieldsEmpty=
    transformedData.containerNumber.length === 0 &&
    !transformedData.bookingNumber &&
    !transformedData.sealNumber &&
    !transformedData.fromDate && 
    !transformedData.toDate;

    const isOnlyDatesFilled = 
    transformedData.containerNumber.length === 0 &&
    !transformedData.bookingNumber &&
    !transformedData.sealNumber &&
    (transformedData.fromDate ||
    transformedData.toDate);
    

    
    if (isAllFieldsEmpty || isOnlyDatesFilled) {
      setDialogHeading("Missing Information");
      setDialogMessage("Please enter a Container Number, Booking Number, or Seal Number");
      setShowDialog(true);
      return;
    }
   
    if(isLoading){
      return;
    }
    onReset();
    onSubmit(transformedData);
    // const transformedData={
    //   ...data,
    //   containerNumber: data.containerNumber[0]?.split(',').map((num) => num.trim()) || [],
    // };
    // onSubmit(transformedData);
  };

  const handleReset = () => {
    reset();
    onReset();
    setIsDisabled(false);
    setBookingDisabled(false);
    setSealDisabled(false);
    setIsFromDateInvalid(false);
    setIsToDateInvalid(false);
  };

  const handleCloseDialog = () => setShowDialog(false);

  return (
    <>
    <div className='d-flex justify-content-between align-items-center mb-3'>
      <h4 className='container-search-heading'>Container Search Dashboard</h4>
      <button className='refresh-status-btn' onClick={handleReset}>
      <McIcon icon="arrow-clockwise" title='Refresh'></McIcon>
      
      </button>
    </div>
      <Form onSubmit={handleSubmit(submitForm)}>
        <Row className="mb-3">
          <Col md={3} xs={12} className='input-container'>
            <Controller
              name="containerNumber"
              control={control}
              render={({ field: { onChange, value } }) => (
                <McInput
                 
                  label='Container Number'
                  aria-label='Container Number'
                  fit='small'
                  placeholder="Enter Container Number"
                  value={value.join(', ')}
                  disabled={isDisabled}
                  input={(e: any) => onChange(handleContainerNumberChange(e.target.value))}
                  onKeyDown={handlekeyDown}
                  
                />
              )}
            />
          </Col>
          <Col md={2} xs={12} className='input-container'>
              <Controller
                name="bookingNumber"
                control={control}
                render={({ field:{ onChange, value }  }) => (
                  <McInput
                    label='Booking Number'
                    aria-label='Booking Number'
                    disabled={isBookingDisabled}
                    fit='small'
                    placeholder="Enter Booking Number"
                    value={value}
                    input={(e: any) => handleBookingInput(e.target.value, onChange)}
                    onKeyDown={handlekeyDown}
                  />
                )}
              />
          </Col>
          <Col md={2} xs={12} className='input-container'>
              <Controller
                name="sealNumber"
                control={control}
                render={({ field:{ onChange, value }  }) => (
                  <McInput
                    label='Seal Number'
                    aria-label='Seal Number'
                    disabled={isSealDisabled}
                    fit='small'
                    placeholder="Enter Seal Number"
                    value={value}
                    input={(e: any) => handleSealInput(e.target.value, onChange)}
                    onKeyDown={handlekeyDown}
                  />
                )}
              />
          </Col>
          <Col md={2} xs={12} className='input-container'>
            <Form.Group controlId="formSubmittedTimeFrom">
              <Controller
                name="fromDate"
                control={control}
                render={({ field:{onChange,value} }) => (
                  <>
                  <McInputDate
                    yearcap={20}
                    label="From"
                    aria-label='From'
                    fit='small'
                    value={value} 
                    invalid={isFromDateInvalid}
                    input={(e: any) => {
                      onChange(e.target.value);
                      validateDate(e.target.value, setIsFromDateInvalid);
                    }}
                    placeholder="YYYY-MM-DD"
                    onKeyDown={handlekeyDown}
                  />
                       <div
            style={{
              color: 'red',
              fontSize: '12px', 
              marginTop: '4px',
              height: '50px', 
              fontFamily: 'Maersk Headline'
            }}
          >
            {isFromDateInvalid ? 'Please enter a valid date.' : '\u00A0'}
          </div>
        </>
                )}
              />
            </Form.Group>
          </Col>
          <Col md={3} xs={12} className='d-flex align-items-end input-container'>
          <div style={{ flexGrow: 1 }}>
            <Form.Group controlId="formSubmittedTimeTo">
              <Controller
                name="toDate"
                control={control}
                render={({ field :{onChange,value}}) => (
                  <>
                  <McInputDate
                    yearcap={20}
                    label="To"
                    aria-label='To'
                    fit='small'
                    value={value}
                    invalid={isToDateInvalid}
                    input={(e: any) => {
                      onChange(e.target.value);
                      validateDate(e.target.value, setIsToDateInvalid);
                    }}
                    placeholder="YYYY-MM-DD"
                    onKeyDown={handlekeyDown}
                  
                  />
                   <div
            style={{
              color: 'red',
              fontSize: '12px', 
              marginTop: '4px',
              height: '0px',
              fontFamily: 'Maersk Headline'
            }}
          >
            {isToDateInvalid ? 'Please enter a valid date.' : '\u00A0'}
          </div>
        </>
                )}
              />
            </Form.Group>
            </div>
            <McButton label='Search' appearance='primary' type='submit' className='submit-button ms-3' disabled={isDisabled|| isBookingDisabled || isSealDisabled || isLoading} fit='small' aria-label='Search' data-testid="search-button" role='button'></McButton>
          </Col>
        </Row>
        <Row className="justify-content-end mt-3 button-row">
          <div className="d-flex button-container">
            {/* <McButton label="Search" appearance="primary" type="submit" className="small-button" /> */}
            {/* <McButton label="Reset" appearance="primary" onClick={handleReset} className="small-button ms-2" /> */}
          </div>
        </Row>
      </Form>

     
    <McDialog
        
        heading={dialogHeading}
        body={dialogMessage}
        zindex={99999}
        open={showDialog} 
        closed={handleCloseDialog} 
      >
        <McButton 
          slot="secondaryAction" 
          appearance="neutral" 
          dialogaction="cancel" 
          onClick={handleCloseDialog} 
          fit="medium"
        >
          Close
        </McButton>
        <McButton 
          slot="primaryAction" 
          dialogaction="ok" 
          onClick={handleCloseDialog} 
          fit="medium"
        >
          Ok
        </McButton>
      </McDialog>
    </>
  );
};

export default ContainerSearchForm;
